import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  title = "KHFErp";
  public showLogin: boolean;

  constructor(private route: ActivatedRoute) {
    if (localStorage.getItem("b2buser")) {
      this.showLogin = true;
    } else this.showLogin = false;
  }
}
